import PairwiseCorrelation from './PairwiseCorrelation';
import BasicComparisonTable from './BasicComparisonTable';

export { BasicComparisonTable, PairwiseCorrelation };
